import { contactField, FilterTargetTypeEnum } from 'consts/data';
import { isArray, isEmpty, isObject, isPlainObject, uniq } from 'lodash';
import { getTimeStamp, momentInstance } from './date-time';
import queryString from 'query-string';
import { timezoneHelpers } from 'providers/TimezoneProvider';

export const parseTargetForSearchContact = (target) => {
  if (isEmpty(target)) {
    return [];
  }

  return target.map((el) => {
    let tagVals = [el.valueContactField];

    if (isArray(el.valueContactField)) {
      tagVals = el.valueContactField.map((el) => el.value);
    }

    if (el.contactField === contactField.creation_date) {
      const { from, to } = timezoneHelpers.convertDateRangeByTimezone({
        from: el.valueContactField.from,
        to: el.valueContactField.to,
        shouldReturnTimestamp: true,
      });
      tagVals = [from, to];
    }

    return {
      tag: el.contactField,
      compareMethod: el.filterType,
      tagVals: tagVals,
    };
  });
};

export const parseTargetToRequest = (target = [], { filterType = 'INCLUDE' } = {}) => {
  if (isEmpty(target)) {
    return {};
  }

  let obj = {};
  const targetByType = target.filter((el) => el.filterType === filterType);
  for (let i = 0; i < targetByType.length; i++) {
    const ele = targetByType[i];

    if ([contactField.children_birthday, contactField.dob].includes(ele.contactField)) {
      const { dateRanges } = ele?.valueContactField || {};
      const from = dateRanges?.from;
      const to = dateRanges?.to;

      const format = 'DD/MM/YYYY';
      const valueParsed = [
        from ? momentInstance(from).format(format) : null,
        to ? momentInstance(to).format(format) : null,
      ];
      obj[ele.contactField] = valueParsed;
      continue;
    }

    if (isArray(ele.valueContactField)) {
      obj[ele.contactField] = obj?.[ele.contactField]
        ? [...obj[ele.contactField], ...ele.valueContactField.map((el) => el.value)]
        : ele.valueContactField.map((el) => el.value);

      //* Uniq value
      obj[ele.contactField] = uniq(obj[ele.contactField]);
      continue;
    }

    if (obj[ele.contactField]) {
      obj[ele.contactField] = [...obj[ele.contactField], `${ele.valueContactField}`];
    } else {
      obj[ele.contactField] = [`${ele.valueContactField}`];
    }

    if (isPlainObject(ele.valueContactField)) {
      /**
       * E.g: valueContactField = {
       *    from: 123,
       *    to: 1234
       * }
       *
       * => [123, 1234]
       */
      if (ele.contactField === contactField.creation_date) {
        const { from, to } = timezoneHelpers.convertDateRangeByTimezone({
          from: ele.valueContactField.from,
          to: ele.valueContactField.to,
          shouldReturnTimestamp: true,
        });

        obj[ele.contactField] = [from, to];
      } else {
        obj[ele.contactField] = [...Object.values(ele.valueContactField)];
      }
    }
  }

  return obj;
};

export const parseFromRespondToResend = (
  target = {},
  { filterType = FilterTargetTypeEnum.INCLUDE } = {}
) => {
  if (isEmpty(target)) {
    return [];
  }

  const tempResult = [];
  Object.entries(target).forEach(([field, value]) => {
    tempResult.push({
      contactField: field,
      valueContactField: isArray(value) ? value.join(', ') : value,
      filterType,
    });
  });

  return tempResult;
};

export const parseToQuerystringTarget = (arr = []) => {
  if (arr) {
    return arr
      .map((el) => {
        if ([contactField.children_birthday, contactField.dob].includes(el.contactField)) {
          const format = 'DD/MM/YYYY';

          const { dateRanges } = el?.valueContactField || {};
          const from = dateRanges?.from || null;
          const to = dateRanges?.to || null;

          return `${el.contactField}=${encodeURIComponent(
            from ? momentInstance(from).format(format) : null
          )}&${el.contactField}=${encodeURIComponent(
            to ? momentInstance(to).format(format) : null
          )}`;
        }

        if (isArray(el?.valueContactField)) {
          if (el?.contactField === contactField.phoneType) {
            // return `${el?.contactField}=${encodeURIComponent(
            //   el?.valueContactField?.map((el) => el.value)
            // )}`;

            return queryString.stringify({
              [el.contactField]: el?.valueContactField?.map((el) => el.value),
            });
          }
        }

        if (isObject(el?.valueContactField)) {
          //! Only for contactField creation date
          if (el?.contactField === contactField.creation_date) {
            return `${el?.contactField}=${encodeURIComponent(
              getTimeStamp(el.valueContactField.from)
            )}&${el?.contactField}=${encodeURIComponent(getTimeStamp(el.valueContactField.to))}`;
          }
          /**
           * E.g:
           * {
           *  valueContactField: {
           *    from: '1234',
           *    to: '456'
           *  } =>
           *  from=1234&to=456
           * }
           *
           */
          return Object.entries(el?.valueContactField)
            .map(([field, value]) => {
              let valueParsed = value;
              if (momentInstance(value).isValid()) {
                valueParsed = getTimeStamp(valueParsed);
              }

              return `${field}=${encodeURIComponent(valueParsed)}`;
            })
            .join('&');
        }

        return `${el.contactField}=${encodeURIComponent(el.valueContactField)}`;
      })
      .join('&');
  }

  return [];
};
